import { z } from 'zod'

export const GrootboekRekeningSchema = z.object({
  code: z.number().int().min(1),
  naam: z.string().min(1),
})

export const RelatieSchema = z.object({
  id: z.string().uuid(),
  naam: z.string().min(1),
  type: z.enum(['Member', 'Vendor']),
})

export const TransactionEntrySchema = z.object({
  id: z.string().uuid(),
  relatieId: z.string().uuid(),
  grootboekrekening: z.number().int().min(1),
  debet: z.number().int().min(0),
  credit: z.number().int().min(0),
})

export const TransactionSchema = z.object({
  id: z.string().uuid(),
  boekstuknr: z.string().min(7), // YYYYNNN
  datum: z.string().regex(/^\d{4}-\d{2}-\d{2}$/), // YYYY-MM-DD
  omschrijving: z.string(),
  entries: z.array(TransactionEntrySchema).min(2),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  stornoForId: z.string().uuid().optional(),
}).refine((data) => {
  const sumDebet = data.entries.reduce((sum, e) => sum + e.debet, 0)
  const sumCredit = data.entries.reduce((sum, e) => sum + e.credit, 0)
  return sumDebet === sumCredit
}, {
  message: "Transaction is not balanced: SUM(debet) !== SUM(credit)",
})

export const SplitAllocationSchema = z.object({
  grootboekrekening: z.number().int().min(1),
  amount: z.number().int(),
})

export const SplitRuleSchema = z.object({
  id: z.string(),
  description: z.string(),
  totalAmount: z.number().int(),
  allocations: z.array(SplitAllocationSchema),
})

export const BusinessRulesSchema = z.object({
  debiteurenRekening: z.number().int().min(1),
  bankRekening: z.number().int().min(1),
  reserveRekeningen: z.array(z.number().int().min(1)),
  kostenRekeningen: z.array(z.number().int().min(1)),
  arrearsThreshold: z.number().int(),
  lockedUntil: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable(),
})

export const BoekhouddataBestandSchema = z.object({
  version: z.literal(1),
  accounts: z.array(GrootboekRekeningSchema),
  relaties: z.array(RelatieSchema),
  transactions: z.array(TransactionSchema),
  sequences: z.record(z.string(), z.number().int().min(0)),
  splitRules: z.array(SplitRuleSchema),
  businessRules: BusinessRulesSchema,
})
